import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalController, PopoverController} from '@ionic/angular';
import {AccountPaymentFavoriteService} from '@wlp/ui-bs-account-payment-favorite';
import {BilletDiscountTypeEnum, BilletLotService, BilletService} from '@wlp/ui-bs-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import {DiscountDto} from '@wlp/ui-px-cashin';
import * as moment from 'moment';
import {LoadingService} from 'src/app/core/layout/services/loading.service';


@Component({
  selector: 'ui-t-form-discount',
  templateUrl: './form-discount.html',
  styleUrls: ['./form-discount.scss'],
})
export class FormDiscount implements OnInit {

  @Input() public discount!: DiscountDto;
  @Input() public billetDueTime: Date;
  @Output() public submitForm = new EventEmitter<string>();
  @Output() public onCancel = new EventEmitter<string>();
  public enableDiscount = false;
  public discountForm: FormGroup;
  public discountFormValue: any;
  public hasEnoughDiscounts = false;
  public selectedDiscount: any = '1';

  constructor(
    private formBuilder: FormBuilder,
    public modalController: ModalController,
    public popoverController: PopoverController,
    public router: Router,
    protected userInfoService: UserInfoService,
    public billetService: BilletService,
    public billetLotService: BilletLotService,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
  ) {
    moment.locale('pt-br');
  }

  public ngOnInit() {
    this.createDiscountForm();
    if (this.discount.type != BilletDiscountTypeEnum.NOT_DISCOUNT) {
      this.enableDiscount = true;
    }
  }

  public onDiscountChange() {
    this.cd.detectChanges();
  }

  public createDiscountForm() {
    const initialDiscountType = this.discount.type;
    const initialDiscounts = this.discount.details.map(discount => {
      const discountMoneyType = [BilletDiscountTypeEnum.FIXED_DISCOUNT, BilletDiscountTypeEnum.FIXED_IN_ADVANCE_DISCOUNT];
      let value = discount.value;
      const days = this.calculateDiscountDeadline(discount.days);
      if (discountMoneyType.includes(initialDiscountType)) {
        value = Number(value).toFixed(2);
      }
      return this.createDiscountItemForm(value, days);
    });
    this.enableDiscount = this.discount.details.length > 0;

    this.discountForm = this.formBuilder.group({
      discountType: new FormControl(initialDiscountType, Validators.compose([Validators.required])),
      discounts: this.formBuilder.array(initialDiscounts),
    });

    this.loadingService.hide();
  }

  public createDiscountItemForm(amount?: string, expirationDate?: string): FormGroup {
    return this.formBuilder.group({
      amount: new FormControl(amount, Validators.compose([Validators.required])),
      expirationDate: new FormControl(expirationDate, Validators.compose([Validators.required])),
    });
  }

  get discounts() {
    return this.discountForm.get("discounts") as FormArray;
  }

  public handleClickSaveButton() {
    this.submitForm.emit();
  }

  public addDiscount(): void {
    if (this.discounts.controls.length < 3) {
      this.discounts.push(this.createDiscountItemForm());

      if (this.discounts.controls.length === 3) {
        this.hasEnoughDiscounts = true;
      }
    }
    this.cd.detectChanges();
  }

  public removeDiscount(index: number): void {
    this.discounts.removeAt(index);
    if (this.discounts.controls.length < 3) {
      this.hasEnoughDiscounts = false;
    }
  }

  public cancel() {
    // console.log('## FormDeadlinePayment.cancel')
    this.onCancel.emit();
  }

  public calculateDiscountDeadline(billetDiscountDays: string) {
    const billetDiscountDaysNumber = parseInt(billetDiscountDays);
    const billetDueTimeMoment = moment(this.billetDueTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    const billetDiscountDeadline = billetDueTimeMoment.add(billetDiscountDaysNumber, 'days');
    const formattedDeadline = billetDiscountDeadline.format('DD/MM/YYYY');
    return formattedDeadline;

  }
}
